__turbopack_context__.v({
  "chartCapture": "ReportChartDisplay-module__i_uSKa__chartCapture",
  "chartNote": "ReportChartDisplay-module__i_uSKa__chartNote",
  "chartStage": "ReportChartDisplay-module__i_uSKa__chartStage",
  "closeButton": "ReportChartDisplay-module__i_uSKa__closeButton",
  "error": "ReportChartDisplay-module__i_uSKa__error",
  "field": "ReportChartDisplay-module__i_uSKa__field",
  "headerActions": "ReportChartDisplay-module__i_uSKa__headerActions",
  "iconButton": "ReportChartDisplay-module__i_uSKa__iconButton",
  "label": "ReportChartDisplay-module__i_uSKa__label",
  "modal": "ReportChartDisplay-module__i_uSKa__modal",
  "modalActions": "ReportChartDisplay-module__i_uSKa__modalActions",
  "modalBackdrop": "ReportChartDisplay-module__i_uSKa__modalBackdrop",
  "modalHeader": "ReportChartDisplay-module__i_uSKa__modalHeader",
  "modalSubtitle": "ReportChartDisplay-module__i_uSKa__modalSubtitle",
  "modalTitle": "ReportChartDisplay-module__i_uSKa__modalTitle",
  "primaryButton": "ReportChartDisplay-module__i_uSKa__primaryButton",
  "secondaryButton": "ReportChartDisplay-module__i_uSKa__secondaryButton",
  "select": "ReportChartDisplay-module__i_uSKa__select",
  "successIcon": "ReportChartDisplay-module__i_uSKa__successIcon",
  "successPanel": "ReportChartDisplay-module__i_uSKa__successPanel",
});
